<div class="fullcontainer pr-3">
  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Reporting</h2>
  </div>

  @if (showAllReports) {
    @for (section of this.reportSections; track section.title) {
      <div class="sheet">
        <h2 class="header" style="font-size: 1.15rem;">{{ section.title }}</h2>
        <div class="row">
          @for (item of section.items; track item.name) {
            <div class="col-4 mb-3">
              @if (!item.disabled && item.internal) {
                <button class="btn btn-block btn-primary" (click)="this.loadReport(item.link)">
                  <i [class]="item.icon"></i> {{ item.name }}
                </button>
              }
              @if (!item.disabled && !item.internal) {
                <button class="btn btn-block btn-primary" [routerLink]="item.link">
                  <i [class]="item.icon"></i> {{ item.name }}
                </button>
              }
              @if (item.disabled) {
                <button class="btn btn-block btn-primary" disabled>
                  <i [class]="item.icon"></i> {{ item.name }}
                </button>
              }
              <small class="text-muted d-block mt-1">{{ item.description }}</small>
            </div>
          }
        </div>
      </div>
    }
  }

  @if (!showAllReports) {
    <div class="row content-block p-3">
      <div class="col">
        <button class='btn btn-info btn-block' (click)='this.loadReport("all")'>All Reports</button>
      </div>
    </div>
    <div class="row content-block mb-2 pb-2">
      <div class="col">
        <label>Start Date</label>
        <input type="date" [(ngModel)]='this.tempStart' class="form-control m-0">
      </div>
      <div class="col">
        <label>End Date</label>
        <input type="date" [(ngModel)]='this.tempEnd' class="form-control m-0">
      </div>
      <div class="col btn-group dropdown">
        <button class='btn btn-block btn-success' (click)='changeDates()'>Update</button><br/>
        <!-- <div class=""> -->
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)='this.exportToCSV()'>Export to CSV</a>
          <!-- <a class="dropdown-item" href="#">Import CSV</a> -->
        </div>
      <!-- </div> -->
    </div>
  </div>
  <div class="row">
    <table class='table table-bordered table-hover'>
      <thead class='thead-dark'>
        <tr>
          <th [attr.colspan]='this.reportData.columnCount'>{{this.reportData.header}}</th>
        </tr>
        <tr>
          @for (column of this.reportData.columns; track column) {
            <th>{{column}}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of this.reportData.data; track row) {
          <tr>
            @for (item of row.row; track item) {
              <td>{{this.handleNull(item)}}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
</div>
